interface BrainWarmupScreenProps {
  onNext: () => void;
}

// 두뇌풀기 진행 안내 페이지
// - 개별 게임(순서 기억하기)을 설명하지 않고, '가벼운 두뇌풀기 게임이 먼저 진행된다'는 점만 전달
// - Visual Anchor: 두뇌풀기를 표현하는 일러스트 이미지
// - 페이지 하단: 결과가 본 체크에 반영되지 않는다는 보조 안내 + 다음 CTA
export default function BrainWarmupScreen({ onNext }: BrainWarmupScreenProps) {
  return (
    <div className="flex flex-col h-full bg-white px-6 animate-fade-in-up">
      {/* Visual Anchor: 타이틀 → 설명 → 일러스트 Visual 을 하나의 콘텐츠 그룹으로 묶는다 */}
      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        <div className="m-auto w-full flex flex-col items-center">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-[26px] font-bold text-foreground-950 leading-snug tracking-tight">
              먼저 가볍게
              <br />
              두뇌풀기 게임을 시작해볼까요?
            </h1>
            <p className="text-[15px] leading-relaxed text-foreground-600 mt-3">
              간단한 게임으로 가볍게 시작해요.
            </p>
          </div>

          {/* 두뇌풀기 게임 Visual: 게임 개념을 표현하는 일러스트 이미지 */}
          <div className="mt-8 w-[248px] h-[248px]">
            <img
              src="https://storage.helloreaddy.io/project_files/a1e21e58-82d2-4e64-8a34-d104a4996fee/5c71da7e-f49f-44cc-a43f-7880390399be_compressed_Frame-1686564578.webp"
              alt="두뇌풀기 게임 일러스트"
              title="두뇌풀기 게임 일러스트"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="shrink-0 pt-4 pb-[calc(20px+env(safe-area-inset-bottom))]">
        {/* 결과 미반영 안내: 경고가 아닌 보조정보로 표현 */}
        <div className="flex items-start gap-2.5 rounded-xl bg-primary-50 px-4 py-3.5 mb-4">
          <i className="ri-information-line text-[16px] text-primary-600 mt-[1px] leading-none" />
          <p className="text-[13px] leading-relaxed text-foreground-600">
            두뇌풀기 결과는 인지건강 체크 결과에 반영되지 않아요.
          </p>
        </div>

        <button
          onClick={onNext}
          className="w-full h-14 rounded-xl sh-cta text-white font-semibold text-base whitespace-nowrap
            active:scale-[0.99] transition-transform duration-150 cursor-pointer"
        >
          다음
        </button>
      </div>
    </div>
  );
}